import { Collapse } from "./Collapse";

class SingleCollapse extends Collapse {
    open(id) {
        this.openItems = [id];
    }
}

export { SingleCollapse };
